import script from "./SettingsDataImportSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsDataImportSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsDataImportSection.vue?vue&type=style&index=0&id=337764ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-337764ae"]])

export default __exports__